const routesWithExternalClickjackProtection = [
  ":instCode/manager/modules/:moduleId/lti",
];

export default routesWithExternalClickjackProtection;
